import { render, staticRenderFns } from "./textAreaInput.vue?vue&type=template&id=1daaa202&scoped=true&"
import script from "./textAreaInput.vue?vue&type=script&lang=js&"
export * from "./textAreaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daaa202",
  null
  
)

export default component.exports